<template>
  <figure class="reference-item">
    <div class="reference-item__content">
      <a
        :href="reference.url"
        @click="clickReferenceHandler"
        rel="noreferrer"
        target="_blank"
      >
        <img :src="reference.thumbnail" />
        <figcaption>
          {{ reference.title }}

          <font-awesome-icon size="sm" icon="external-link-alt" />
        </figcaption>
      </a>
    </div>
  </figure>
</template>

<script>
export default {
  name: 'study-reference-item',
  props: ['reference'],
  methods: {
    clickReferenceHandler() {
      this.$gtag.event('view_reference', {
        event_category: 'participation',
        event_label: 'Open link to reference',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-item {
  position: relative;
  display: flex;
  background: #333;
  flex: 1;
  width: 100%;
  overflow: hidden;

  &:hover {
    img {
      transform: scale(1.1);
    }
  }

  &:hover figcaption {
    color: color('primary', 'light');
  }

  &__content {
    display: flex;
    flex: 1;

    a {
      display: flex;
      flex: 1;
    }
  }

  img {
    min-width: 100%;
    max-width: 100%;
    align-self: center;
    vertical-align: bottom;
    transform: scale(1);
    transition: transform 128ms ease-in-out;
  }

  figcaption {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.75rem;
    color: white;
    background: rgba(black, 0.7);
  }

  @media screen and (min-width: 1024px) {
    &:before {
      content: '';
      padding-bottom: 100%;
      display: block;
    }

    &__content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
